module.exports = __webpack_public_path__ + "static/dexa.dc4bdf51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/header/dexa.jpg
// module id = 161
// module chunks = 176948426173393 206907524185279